export default __webpack_public_path__ + "static/media/icon-group-circle-solid.b2fd7b7b.svg";